




































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class JoinUs extends Vue {
  goToCV() {
    this.$router.push("/AboutUs/YourCV");
  }
}
